/* RESPONSIBLE TEAM: team-self-serve */
/* === ⚠️ THIS FILE CURRENTLY USES DEPRECATED PATTERNS ⚠️ === */
/* === 🔗 For more information visit https://go.inter.com/ember-best-practices 🔗 */
/* === 🚀 Please consider refactoring & removing some of the comments below when working on this file 🚀 */
/* eslint-disable @intercom/intercom/no-bare-strings */
import Route from '@ember/routing/route';
import type RouterService from '@ember/routing/router-service';
import { inject as service } from '@ember/service';

export default class IntershopProductsProductRoute extends Route {
  @service declare appService: any;
  @service declare notificationsService: any;
  @service declare router: RouterService;

  get app() {
    return this.appService.app;
  }

  redirect() {
    if (!this.app.canAccessIntershop) {
      this.router.transitionTo('apps.app');
    }
  }

  async model(params: any) {
    return this.app.products.findBy('slug', params.product_slug);
  }

  serialize(model: any) {
    return { product_slug: model.slug };
  }

  afterModel(model: any) {
    if (!model) {
      this.notificationsService.notifyError('Sorry these product plans cannot be found');
      this.router.transitionTo('apps.app.intershop');
    }
  }
}
